<div class="flex flex-col">
  <div class="flex items-center justify-between mb-4">
    <div class="text-2xl leading-tight">Add Members</div>
    <button mat-icon-button matDialogClose><mat-icon svgIcon="mat_solid:close"></mat-icon></button>
  </div>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Invite via email">
      <div class="py-4">
        <div class="flex flex-col gap-4" [formGroup]="inviteForm">
          <mat-form-field [subscriptSizing]="'dynamic'" class="w-full fuse-mat-dense">
            <mat-label>Emails</mat-label>
            <mat-chip-grid #chipGrid aria-label="Enter email" formControlName="emails">
              <mat-chip-row *ngFor="let email of emailsFC.value" (removed)="removeEmail(email)" [value]="email">
                {{email}}
                <mat-icon class="icon-size-5" matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input placeholder="Enter email address" [matChipInputFor]="chipGrid" #emailInput
                (matChipInputTokenEnd)="addEmail($event.value)" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
            </mat-chip-grid>
            <button *ngIf="emailInput.value" mat-icon-button matSuffix (click)="addEmail(emailInput.value)">
              <mat-icon svgIcon="mat_solid:attach_email"></mat-icon>
            </button>
            <mat-hint>e.g.: name@example.com, name@sample.com</mat-hint>
            <mat-error *ngIf="emailsFC.hasError('required')">Enter emails separated by a comma, space or Press Enter!</mat-error>
            <mat-error *ngIf="emailsFC.hasError('isNotValid')">Is not a valid email!</mat-error>
          </mat-form-field>
          <tm-autocopmlete-select-projects [required]="false"></tm-autocopmlete-select-projects>
          <mat-form-field *ngIf="roleFC.enabled" [subscriptSizing]="'dynamic'" class="w-full fuse-mat-dense">
            <mat-label>Role</mat-label>
            <mat-select formControlName="role">
              <mat-option value="Member">Member</mat-option>
              <mat-option value="Manager">Manager</mat-option>
            </mat-select>
            <mat-error>Role is requred!</mat-error>
          </mat-form-field>
        </div>
        <div class="flex justify-end mt-4 gap-2">
          <button mat-stroked-button matDialogClose>Cancel</button>
          <button mat-raised-button color="primary" [disabled]="inviteForm.invalid || (submitting$ | async)" (click)="submit()">
            <div class="flex gap-2 items-center">
              <mat-spinner *ngIf="submitting$ | async" diameter="25"></mat-spinner>
              <span>Send</span>
            </div>
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>